import logo from './logo.svg';
import './App.css';
import Navbar from "./components/Navbar.jsx";
import Banner from "./components/Banner.jsx";
import Movies from "./components/Movies.jsx";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Favourites from './components/Favourites';
import PageNotFound from './components/PageNotFound';

function App() {
  return (
    <BrowserRouter>
      <Navbar></Navbar>

      <Routes>
        <Route path="/" element={<><Banner></Banner>
          <Movies></Movies></>}>
        </Route>
        <Route path="/fav" element={<><Favourites></Favourites></>}>
        </Route>
        <Route path="*" element={<><PageNotFound></PageNotFound></>}></Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
